import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import apiService from 'common/services/api/apiService';
import FetchStatus from 'common/types/FetchStatus';
import { AppThunk } from 'configureStore';

type ProfileVerification = {
  typeCd: string; // TODO enum
  typeDescr: string;
  statusCd: string; // TODO enum
  statusDescr: string;
};

type VerificationsState = {
  data: ProfileVerification[];
  meta: {
    fetchStatus: FetchStatus;
  };
};

export const initialState: VerificationsState = {
  data: [],
  meta: {
    fetchStatus: FetchStatus.none,
  },
};

const VerificationsSlice = createSlice({
  name: 'Verifications',
  initialState,
  reducers: {
    fetchVerificationsStart(state) {
      state.meta.fetchStatus = FetchStatus.loading;
      return state;
    },
    fetchVerificationsSuccess(
      state,
      action: PayloadAction<{ data: ProfileVerification[] }>
    ) {
      state.meta.fetchStatus = FetchStatus.loaded;
      state.data = action.payload.data;
      return state;
    },
  },
});

export function fetchProfileVerifications(): AppThunk<Promise<void>> {
  return async function (dispatch, getState) {
    dispatch(VerificationsSlice.actions.fetchVerificationsStart());

    const {
      auth: { access_token },
    } = getState();

    let error;

    try {
      const res = await apiService.get(`/profile/verifications`, access_token);
      if (res.ok) {
        const profileVerifications =
          (await res.json()) as ProfileVerification[];
        dispatch(
          VerificationsSlice.actions.fetchVerificationsSuccess({
            data: profileVerifications,
          })
        );
        return Promise.resolve();
      }
      error = await res.json();
    } catch (e) {
      error = (e instanceof Error && e.message.toString()) || '';
    }

    return Promise.reject(error);
  };
}

export default VerificationsSlice.reducer;
